import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';

const InformationSection = () => {
  const sectionVariants = {
    Visible: { y: 0, opacity: 1, transition: { duration: 0.4 } },
    hidden: { y: 100, opacity: 0 },
  };

  return (
    <Container className='information-section'>
      <Row>
        <Col lg='6' className='fs-7 px-3 font-weight-bold'>
          <motion.div variants={sectionVariants} initial='hidden' whileInView='Visible'>
            <p>
              <span>
                私の使命は、見る人に世界の違う側面を伝えることです。
              </span>
            </p>
          </motion.div>
        </Col>
        <Col lg='6' className='px-3'>
          <motion.div variants={sectionVariants} initial='hidden' whileInView='Visible'>
            <p>
              私の使命は、見る人に世界の違う側面を伝えることです。
            </p>
          </motion.div>
        </Col>
      </Row>
    </Container>
  );
};

export default InformationSection;